import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Register2 from "../sections/auth/Register2";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const promise = loadStripe(
  `${process.env.REACT_APP_stripeSecretKeyP}`
);

const Payment = () => {
  return (
    <div>
      <Elements stripe={promise}>
        <Register2 />
      </Elements>
    </div>
  );
};

export default Payment;
